export const DayPeriod = {
  None: 0,
  AM: 1,
  PM: 2,
};
